/* eslint-disable */

import React from "react";
import gettext from "../../shared/utils/gettext";
import LinkPartner from "./LinkedPartner";

class LinkVervaet extends React.Component {
  render() {
    return (
      <LinkPartner
        gid="myvervaetnl"
        name="Vervaet"
        logo_url="/static/img/vervaet.png"
        logo_height="50"
        description={
          <>
            {gettext(
              "Cloudfarm offers integration with My Vervaet. Through this system, the yield data will become automatically available in Cloudfarm and the harvest operation will be automatically recorded in Dacom."
            )}
            <p className="mt-1">
              {gettext("To configure the connection or get more information, please visit")}&nbsp;
              <a href="http://my.vervaet.nl" target="_blank">
                {gettext("the Vervaet website")}
              </a>
              .
            </p>
          </>
        }
      />
    );
  }
}

export default LinkVervaet;
